__turbopack_context__.v({
  "container": "SectionRowsTemplate-module__VHp1lq__container",
  "sectionRowsContainer": "SectionRowsTemplate-module__VHp1lq__sectionRowsContainer",
  "sectionRowsContainerInverseStripes": "SectionRowsTemplate-module__VHp1lq__sectionRowsContainerInverseStripes",
  "styledSection": "SectionRowsTemplate-module__VHp1lq__styledSection",
  "titleLine": "SectionRowsTemplate-module__VHp1lq__titleLine",
});
